import "./dpopSetup";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ContextProvider from "./context/ContextProvider";
import axios from "axios";
import { decryptData, encryptData } from "./crypto";

// Global interceptor to handle generic token expiry or logout messages
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const errorMsg = error.response?.data?.message;

    // 🔄 Handle Token Refresh
    if (errorMsg === "jwt expired" && !originalRequest._retry && !originalRequest.url?.includes("/v1/b2b/client/auth/re_login")) {
      originalRequest._retry = true;
      try {
        const encryptedRefreshToken = sessionStorage.getItem("refresh_token");
        const refreshToken = decryptData(encryptedRefreshToken);

        if (refreshToken) {
          const res = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/client/auth/re_login`,
            {
              headers: { "x-refreshtoken": refreshToken },
            }
          );

          if (res.data.success) {
            const newToken = res.data.token;
            const newRefreshToken = res.data.refresh_token;

            sessionStorage.setItem("token", encryptData(newToken));
            if (newRefreshToken) {
              sessionStorage.setItem("refresh_token", encryptData(newRefreshToken));
            }

            // Update Header and Retry Original Request
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return axios(originalRequest);
          }
        }
      } catch (err) {
        console.error("Token refresh failed:", err);
      }
    }

    if (
      errorMsg === "Invalid or expired session. Please refresh your session." ||
      errorMsg === "You are logged out. Please log in again." ||
      errorMsg === "Session expired. Please log in again." ||
      errorMsg === "jwt expired" ||
      errorMsg === "No auth token"||
      errorMsg === "Invalid or expired session. Please log in again."||

      errorMsg === "Key does not match token binding"  // jb privet and public key mismatch issue koi or token ko acces krne ke try krta h without authourised
      || errorMsg === "Missing DPoP proof" // JWT header.typ is not "dpop+jwt
      || errorMsg === "Invalid DPoP alg" // Invalid DPoP algorithm (JWT header.alg is not ES256)
      || errorMsg === "Invalid DPoP key" //Missing/invalid JWK. - Key is not EC P-256
      || errorMsg ==="DPoP proof expired" //payload.iat is older/newer than allowed window (5 min)
      || errorMsg === "Missing jti" //Unique proof identifier was not included in payload.
      || errorMsg === "HTTP method mismatch"// payload.htm does not match actual request method.
      || errorMsg === "URL mismatch" //payload.htu does not match actual API URL. - Host, protocol, path, or trailing slash may differ.
      || errorMsg === "Access-token hash mismatch" //payload.ath was generated using a different access token.
      ||errorMsg === "DPoP proof replay detected"
      // errorMsg === "invalid token"
    ) {
      window.dispatchEvent(new CustomEvent("session-expired"));
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <ContextProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ContextProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
